export enum ShipmentType {
  FCL = 0,
  LCL = 1,
  Breakbulk = 2,
  Roro = 3,
  FTL = 4,
  LTL = 5,
  Haulage = 6
}
